/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect} from "react";

export const useDidMount = (fn: VoidFunction): void => {
  useEffect(() => fn && fn(), []);
};
